function memoize(fn) {
  const memoized = (...args) => {
    const cacheKey = JSON.stringify(...args);

    if (cacheKey in memoized.cache) {
      return memoized.cache[cacheKey];
    }

    memoized.cache[cacheKey] = fn.apply(this, args);

    return memoized.cache[cacheKey];
  };

  memoized.cache = Object.create(null);

  return memoized;
}

export default memoize;
